export class AmazonQuantity {
    public unit: string;
    public amount: number;

    constructor(unit: string = 'count', amount: number = 1) {
        this.unit = unit;
        this.amount = amount;
    }
}

export class AmazonFreshItem {
    public name: string;
    public description: string;
    public brand: string | null;
    public asinOverride: string | null;
    public staple: boolean;
    public quantityList: AmazonQuantity[];

    constructor(
        name: string,
        description: string,
        brand: string | null = null,
        asinOverride: string | null = null,
        staple: boolean = false,
        quantityList: AmazonQuantity[] = []) {
        this.name = name;
        this.description = description;
        this.brand = brand;
        this.asinOverride = asinOverride;
        this.staple = staple;
        this.quantityList = quantityList;
    }
}

